import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
const keyframesAnimation = keyframes `
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
`;
export const ShimmerStyled = styled.div `
	display: flex;
	flex-direction: ${(props) => props.direction || 'column'};
	width: 100%;
	height: 100%;
	gap: ${(props) => props.gap || '0px'};

	.shine {
		border-radius: 4px;
		background: ${(props) => props.isBrand
    ? 'linear-gradient(90deg, rgba(255, 255, 255, 0.30) 0%, rgba(224, 224, 224, 0.00) 100%)'
    : '#f6f7f8 linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #F0F0F0 100%) no-repeat'};
		background-size: 800px 304px;
		display: inline-block;
		position: relative;

		-webkit-animation-duration: 1s;
		-webkit-animation-fill-mode: forwards;
		-webkit-animation-iteration-count: infinite;
		-webkit-animation-name: ${keyframesAnimation};
		-webkit-animation-timing-function: linear;
	}
`;
export const ShimmerComponentStyled = styled.div `
	border-radius: 4px;
	background: ${(props) => props.isBrand
    ? 'linear-gradient(90deg, rgba(255, 255, 255, 0.30) 0%, rgba(224, 224, 224, 0.00) 100%)'
    : '#f6f7f8 linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #F0F0F0 100%) no-repeat'};
	width: ${(props) => props.width}px;
	height: ${(props) => props.height}px;
	margin-top: ${(props) => props.marginTop || 0}px;
	display: inline-block;
	position: relative;
	-webkit-animation-duration: 1s;
	-webkit-animation-fill-mode: forwards;
	-webkit-animation-iteration-count: infinite;
	-webkit-animation-name: ${keyframesAnimation};
	-webkit-animation-timing-function: linear;
`;
//# sourceMappingURL=ShimmerStyled.js.map